import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UIError {
  id: number;
  message: string;
}

export interface UiState {
  errors: UIError[];
  routeHistory: string[];
}

const initialState: UiState = {
  errors: [],
  routeHistory: []
};

const uiSlice = createSlice({
  name: 'UI',
  initialState,
  reducers: {
    setError(state, action: PayloadAction<string>) {
      const message = action.payload;
      return {
        ...state,
        errors: [
          ...state.errors,
          {
            message,
            id: ++state.errors.length
          }
        ]
      };
    },
    removeError(state, action: PayloadAction<number>) {
      const removeId = action.payload;
      return {
        ...state,
        errors: [...state.errors.filter(({ id }) => id !== removeId)]
      };
    },
    addRouteToHistory(state, action: PayloadAction<string>) {
      const route = action.payload;
      return {
        ...state,
        routeHistory: [...state.routeHistory, route]
      };
    }
  }
});

export const { setError, removeError, addRouteToHistory } = uiSlice.actions;
export default uiSlice.reducer;
